'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderLogoDataOption = exports.ProviderDropdownId = exports.ProviderFilter = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.getProviderLogo = getProviderLogo;
exports.isValidProvider = isValidProvider;
exports.setProviderInStorage = setProviderInStorage;
exports.navigateToAuthorization = navigateToAuthorization;
exports.getProviderFromStorage = getProviderFromStorage;
exports.getProviderRequest = getProviderRequest;
exports.getProvider = getProvider;

var _createLoginClient = require('../helpers/createLoginClient');

var _createLoginClient2 = _interopRequireDefault(_createLoginClient);

var _Cookie = require('../helpers/Cookie');

var _Error = require('../helpers/Error');

var _ClientError = require('../helpers/ClientError');

var _Router = require('../helpers/Router');

var _SessionStorage = require('../helpers/SessionStorage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProviderFilter = exports.ProviderFilter = {
  All: 'ALL',
  CurrentCountry: 'CURRENT_COUNTRY',
  SearchName: 'SEARCH_NAME',
  TopProvider: 'TOP_PROVIDER'
};

var ProviderDropdownId = exports.ProviderDropdownId = {
  All: 'all',
  Local: 'local'
};

var ProviderLogoDataOption = exports.ProviderLogoDataOption = {
  OperatorLogoColorMedium: 'OPERATOR_LOGO_COLOR_MEDIUM'
};

function getProviderLogo(provider) {
  var logoUri = '';
  if (provider && provider.logo) {
    provider.logo.forEach(function (logo) {
      if (logo.dataOption === ProviderLogoDataOption.OperatorLogoColorMedium) {
        logoUri = logo.uri;
      }
    });
  }
  return logoUri;
}

function isValidProvider(provider) {
  return provider.visible && provider.serviceAvailable;
}

function setProviderInStorage(key, provider) {
  (0, _SessionStorage.saveDataInSessionStorage)(key, (0, _stringify2.default)(provider));
}

function navigateToAuthorization(provider, pushState, auth, startGracePeriod) {
  if (auth.autoGracePeriod && auth.userInfo && auth.userInfo.canStartGracePeriod) {
    startGracePeriod(provider.id);
  } else {
    setProviderInStorage(_SessionStorage.SessionStorageKeys.SelectedProviderKey, provider);
    pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.Authorization));
  }
}

function getProviderFromStorage(key) {
  return JSON.parse((0, _SessionStorage.getDataFromSessionStorage)(key));
}

function getProviderRequest(operatorId, auth, storageKey, callback) {
  var _this = this;

  (0, _createLoginClient2.default)().then(function (loginClient) {
    return loginClient.operator.getOperator({
      id: operatorId,
      languageTag: auth.lang,
      clientId: auth.clientId }, { responseContentType: 'application/json' }).then(function (result) {
      var providerResult = result.obj.operator;
      setProviderInStorage(storageKey, providerResult);
      callback(providerResult);
    }).catch(function (error) {
      (0, _Error.logError)(error.statusText);
    });
  }).catch(function (error) {
    (0, _ClientError.createLoginClientError)(error, new Error().stack, _this.props.pushState, auth);
  });
}

function getProvider(auth, callback) {
  var cookieProviderId = (0, _Cookie.getCookieValue)(_Cookie.operatorIdCookie);
  if (cookieProviderId) {
    (0, _Cookie.deleteCookie)(_Cookie.operatorIdCookie);
    getProviderRequest(auth.userInfo.account.operatorId, auth, _SessionStorage.SessionStorageKeys.SelectedProviderKey, callback);
  } else {
    var provider = getProviderFromStorage(_SessionStorage.SessionStorageKeys.SelectedProviderKey);
    callback(provider);
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Provider.js
// module id = 62
// module chunks = 0